module.exports = __webpack_public_path__ + "static/media/pond-lighting.c745243e.jpeg";